export const  project0 = require("../images/project0.png");
export const  project1 = require("../images/project1.png");
export const  project2 = require("../images/project2.png");
export const  project3 = require("../images/project3.PNG");
export const  project4 = require("../images/project4.png");
export const  project5 = require("../images/project5.png");


export const  mahendra = require("../images/mahendra.png");